(function (ws) {
    'use strict';
    ws.models.modalTableProductModel = Backbone.Model.extend({
        /**
         * validates quantity checking SBA tag restriction in split order overlay
         */
        isQtyInvalidOnRestricted: function() {
            return this.get('restrictQty') && this.get('qtyToOrder') + this.get('quantityConverted') > this.get('quantityQuoted');
        }
    });
})(westcon);
